module.exports = (__webpack_require__(/*! dll-reference react_library */ 37))(0);